// Shared helpers for the Trio / V-Trio bet tables (reference markets, book lookup).
// "3 Card Judgement (1 2 4)" and "3 Card Judgement(1 2 4)" are the same market
const norm = (s) =>
  String(s || "")
    .replace(/\s*\(\s*/g, "(")
    .replace(/\s*\)\s*/g, ")")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export function getTrioExposure(exposures = {}, nat) {
  if (!nat) return 0;
  const direct = exposures[nat] ?? exposures[String(nat).toLowerCase()] ?? exposures[String(nat).trim()];
  if (direct != null && !isNaN(parseFloat(direct))) return parseFloat(direct);
  const key = norm(nat);
  for (const k in exposures) {
    if (norm(k) === key) {
      const v = parseFloat(exposures[k]);
      if (!isNaN(v)) return v;
    }
  }
  return 0;
}

// Reference v-casinofancybook: amt > 0 → book-green, else book-red
export const bookClass = (amt) => (amt > 0 ? "book-green" : "book-red");

/** Reference: markets = sub filtered by subtype (prefixed with "v" on the virtual feed), ordered by sr, first one used */
export function trioMarkets(sub = [], prefix = "") {
  const list = Array.isArray(sub) ? sub : [];
  const pick = (subtype) =>
    [...list.filter((s) => s?.subtype === `${prefix}${subtype}`)].sort((a, b) => (a?.sr ?? 0) - (b?.sr ?? 0))[0] || {};
  return {
    trio: pick("trio"),
    section124: pick("124"),
    jqk1: pick("jqk1"),
    red2: pick("red2"),
    black2: pick("black2"),
    odd2: pick("odd2"),
    even2: pick("even2"),
    pair2: pick("pair2"),
    flush: pick("flush"),
    straight: pick("straight"),
    trio1: pick("trio1"),
    straightflush: pick("straightflush"),
  };
}
